<template>
    <v-dialog
        hide-overlay
        persistent
        v-model="dialog"
        width="80%">
        <v-card :dark="creating">
            <Editor  v-if="!creating" @save="sendProno" />
                <v-card-text v-else>
                Sending pronostic...
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { firestore, auth, storage, ui, uiConfig } from "@/firebase";
import Editor from "@/components/baby/Editor";

export default {
  data() {
    return {
      dialog: true,
      creating: false
    };
  },
  methods: {
    sendProno(prono) {
      this.creating = true;
      firestore
        .collection("babies")
        .doc(this.$route.params.id)
        .collection("pronos")
        .doc(auth.currentUser.uid)
        .set({
          ...prono,
          created: new Date(),
          updated: new Date()
        })
        .then(doc => {
          setTimeout(() => {
            this.creating = false;
            this.$router.replace(
              `/dashboard/${this.$route.params.id}/timeline`
            );
            // location.reload();
          }, 2000);
        })
        .catch(err => {
          this.creating = false;
          alert("Pronostic creation error ! Either pronotics are disabled or you've already registered your pronostic");
          this.$router.push(`/dashboard/${this.$route.params.id}/timeline`);
        });
      firestore
        .collection("users")
        .doc(auth.currentUser.uid)
        .collection("pronos")
        .doc(this.$route.params.id)
        .set({
          ...prono,
          created: new Date(),
          updated: new Date()
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  components: {
    Editor
  }
};
</script>
